import { ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";

const Layout = ({ children }: { children: ReactNode }) => (
  <div className="min-h-screen flex flex-col">
    <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:bg-primary focus:text-primary-foreground focus:px-4 focus:py-2 focus:rounded-md focus:font-body focus:font-semibold">
      Aller au contenu principal
    </a>
    <Navbar />
    <main id="main-content" className="flex-1 pt-20" role="main">{children}</main>
    <Footer />
    <WhatsAppButton />
  </div>
);

export default Layout;
